module.exports = __webpack_public_path__ + "img/icon_personal_msg.578845d0.svg";